import { Metadata } from "src/app/hickory-api";

export class AuthzConstants {
  public static readonly OWNER_TAG = 'Owner';
  public static readonly EVERYONE_PREFIX = 'everyone-'
  public static getEveryoneActionKey = (action: string) => `${this.EVERYONE_PREFIX}${action}`;
  public static isEveryoneActionEnabled(action: string, metadata: Metadata) {
    if (!metadata?.tags || !Object.keys(metadata?.tags)?.length) return false;
    return metadata?.tags[this.getEveryoneActionKey(action)]?.indexOf('allow') > -1
  }
}